const stylesTemplate = {
    template: {
        relatorioTitulo: {
            fontSize: 20,
            bold: true,
        },
        cabecalhoTexto1: {
            fontSize: 18,
            bold: true,
        },
        cabecalhoTexto2: {
            fontSize: 12,
            bold: false,

        },
        rodapeTexto: {
            fontSize: 10,
        }
    },
    cellTitulo: {
        margin: [1, 1, 1, 1],
        fontSize: 9,
        bold: true,
        // fillColor: '#dcdcdc',
    },
    cellValor: {
        margin: [1, 1, 1, 1],
        fontSize: 9,
        // fillColor: '#f0f0f0',
    },
    cellLimpo: {
        margin: [1, 1, 1, 1],
        fontSize: 9,
    },
    fieldsetTitulo: {
        margin: [2, 2, 2, 2],
        fontSize: 11,
        bold: true,
        fillColor: '#285137',
        color: 'white'
    }
}
export function gerar(relatorioCustom, conteudo, meta) {
    return gerarDocumento(relatorioCustom, conteudo, meta)
}
export function gerarDocumento(relatorioCustom, conteudo, meta) {


    let stylesUsar = stylesTemplate;

    const { styles } = relatorioCustom
    if (styles) {
        stylesUsar = { ...stylesUsar, ...styles }
    }





    const documentImprimir = templatePadrao(conteudo, stylesUsar);
    return documentImprimir
}




export function templatePadrao(conteudo, styles) {

    const documentDefinition = {
        pageMargins: [10, 5, 10, 5],
        pageSize: {
            width: (90 / 25.4) * 72,
            height: (30 / 25.4) * 72
        },
        pageOrientation: styles.orientation,
        content: conteudo,
        styles: styles,

    };

    return documentDefinition;
}